import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-FullText",
  "use": "svg-icon-FullText-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-FullText\"><path d=\"M15 3H1V1h14v2zM5 11H1V9h4v2zM1 7h8V5H1v2zm6 8H1v-2h6v2zm2 0h6v-2H9v2zm-2-4h8V9H7v2zm4-4h4V5h-4v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol